module.exports = __webpack_public_path__ + "img/chg-ministerio.dfd29ef9.png";